import Abstract from './Abstract.js';

export default class MilestoneBar extends Abstract {
  build() {
    const {
      chart,
      options: { width },
    } = this.props;
    const group = chart
      .selectAll('svg')
      .data([1])
      .enter()
      .append('g')
      .attr('class', 'mile-bar');
    group
      .append('rect')
      .attr('class', 'mile-bar')
      .attr('width', width)
      .attr('x', 0)
      .attr('y', 42)
      .attr('height', 24);

    group
      .append('rect')
      .attr('width', width)
      .attr('x', 0)
      .attr('y', 43)
      .attr('height', 1)
      .attr('class', 'mile-bar-border');
    group
      .append('rect')
      .attr('width', width)
      .attr('x', 0)
      .attr('y', 65)
      .attr('height', 1)
      .attr('class', 'mile-bar-border');
  }
}
